var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-container",class:_vm.classes},[_c('span',{staticClass:"account-status-dot custom-badge",style:({ backgroundColor: _vm.getStatusColor }),attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"status-label"},[_vm._v(_vm._s(_vm.computedStatus))])])
}
var staticRenderFns = []

export { render, staticRenderFns }